import { useHeaderSlot } from '@src/app/layout';
import { ToastContainer } from '@src/app/notifications/toast';
import type { Theme } from '@src/app/themes';
import { useAuthentication } from '@src/features/auth';
import { Box } from '@src/shared/ui/layout';

const StyleSheet = {
  header: {
    position: 'relative',
    marginBottom: '10px',
  },
  loginAsNotification: (theme: Theme) => ({
    position: 'absolute',
    top: '10px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: theme.palette.red[500],
    padding: '0 16px',
    opacity: 0.8,
  }),
};
export default function Header() {
  const { user, credentials } = useAuthentication();
  const { headerSlot } = useHeaderSlot();
  const loginAs = credentials?.loginAs ?? false;
  return (
    <Box sx={StyleSheet.header}>
      {loginAs && (
        <Box sx={StyleSheet.loginAsNotification}>Login as {user?.name}</Box>
      )}
      <ToastContainer />
      {headerSlot}
    </Box>
  );
}
